<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.prepaid && prepaidReasons && wrapper">
    <div style="max-width:1200px;" class="banner center">
      <div class="row">
        <div class="col-6">
          <app-prepaid-pin *ngIf="interactionType == 2" [businessId]="businessId"
            [interactionType]="interactionType"></app-prepaid-pin>
        </div>
        <div class="col-6" style="text-align:right;">
          <input autocomplete="off" [id]="elementIds.txt_amount" type="number" class="number"
            [ngClass]="amountToRecharge ? 'en' : ''" style="max-width:200px;"
            (keypress)="localService.isNumberOnly($event,numericConfig)" [(ngModel)]="amountToRecharge"
            placeholder="*{{localService.languageContent.prepaid.amount}}"
            title="*{{localService.languageContent.common.amount}}" (keydown.enter)="onAddAmount()" />
          &nbsp;
          <button class="btn btn-primary" (click)="onAddAmount()">
            {{localService.languageContent.prepaid.add_amount}}
          </button>
        </div>
      </div>
      <div class="row row_header freeze_col freeze_height">
        <div class="col-3">
          <span>{{localService.languageContent.prepaid.created_on}}</span>
        </div>
        <div class="col-2">
          <span>{{localService.languageContent.prepaid.amount}}</span>
        </div>
        <div class="col-2">
          <span>{{localService.languageContent.prepaid.balance}}</span>
        </div>
        <div class="col-5">
          <span>{{localService.languageContent.prepaid.reason}}</span>
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row" *ngFor="let item of wrapper.items">
          <div class="col-3 en">
            {{item.v1 | localDate}}
          </div>
          <div class="col-2" style="text-align:right;">
            <span class="en">{{item.v3}}{{item.v2 | number: '1.2-2'}}</span>
          </div>
          <div class="col-2" style="text-align:right;">
            <span class="en">{{item.v5 | number: '1.2-2'}}</span>
          </div>
          <div class="col-5">
            <span>{{localService.getText(prepaidReasons,item.v4)}}</span>
          </div>
        </div>
      </div>
    </div>
    <app-paging [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()"></app-paging>
  </div>
  <app-payments [(isShowPayment)]="isShowPayment" [amount]="amountToRecharge" [paidType]="3"
    [businessOrUserId]="businessId" (onPaymentProccesed)="onPaymentProccesed($event)" [interactionType]="interactionType" />
</div>